import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Command, CommandBase } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { IncorrectPaymentCommand } from '../../command/incorrect-payment';
import { VoidPaymentFormComponent } from '../../component/void-payment-form/void-payment-form.component';
import { IncorrectPayment } from '../../model/incorrect-payment';

@Injectable()
export class VoidPaymentCommandHandler implements ICommandHandler {
  constructor(
    private _actionWindow: ActionWindowService,
    private _injector: Injector,
    private _navigationService: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === IncorrectPaymentCommand.voidPayment && command.context instanceof IncorrectPayment;
    }
    return false;
  }
  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      return this._actionWindow.open(VoidPaymentFormComponent, this._injector, null, command.context).pipe(
        map(result => {
          if (result) {
            this._navigationService.reloadCurrentRoute();
          }
        })
      );
    }
  }
}
